import { Directive, Input } from '@angular/core';
import { MatMenu, MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';

@Directive({
    selector: `[ngxMatMenuTriggerFor]`,
    exportAs: 'ngxMatMenuTrigger',
    standalone: false
})
export class NgxMatMenuTriggerDirective extends MatMenuTrigger {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override _handleClick(event: MouseEvent): void {
    // Nothing to do
  }

  @Input('ngxMatMenuTriggerFor')
  override get menu(): MatMenuPanel {
    return super.menu;
  }

  override set menu(menu: MatMenuPanel) {
    super.menu = menu;
  }
}
